import React, { Children } from 'react';
import classNames from 'classnames';
import Item from './Item';

/*::
type Props = {
  alignEnd?: boolean,
  children?: Array<Button>,
  className?: string,
}
*/

const ButtonGroup = ({ alignEnd, children, className } /*: Props */) => {
  const hasClassName = !!className;
  const groupClassNames = classNames('ButtonGroup', {
    'ButtonGroup--alignEnd': alignEnd,
    [className]: hasClassName,
  });

  const buttons = Children.map(children, (child, i) => {
    return child ? <Item children={child} index={i} /> : null;
  });

  return <div className={groupClassNames}>{buttons}</div>;
};

export default ButtonGroup;
